export default __webpack_public_path__ + "static/media/icon-question.abcf05cd.svg";